import { MlFormField } from '@curran-catalog/curran-atomic-library'
import {
  CloudinaryAsset,
  ContentfulObjAddon,
  ContentfulObjFurnitureFabricGrade,
  ContentfulObjFurnitureMainCushion,
} from 'types'
import Image from 'next/image'
import { useFurnitureProduct } from '@hooks/use-furniture-product'
import { FurnitureProductActionTypes } from '@context/furniture-product'
import { MutableRefObject } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { environment } from '@config/environment'
interface ProductProp {
  name?: string
  image?: CloudinaryAsset
  addons?: ContentfulObjAddon[]
  mainCushion?: ContentfulObjFurnitureMainCushion[]
  fabric?: ContentfulObjFurnitureFabricGrade[]
  fabricTitle?: string
  mainCushionsTitle?: string
  addonsTitle?: string
}

interface TmCustomerServiceProp {
  product: ProductProp
  recaptchaRef: MutableRefObject<ReCAPTCHA | null>
}

const TmCustomerService = ({ product, recaptchaRef }: TmCustomerServiceProp) => {
  const { state, dispatch } = useFurnitureProduct()
  const { quoteDetails } = state
  const RECAPTCHA_SITE_KEY = environment.recaptcha.siteKey
  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
    dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { error: '' } })
    if (fieldName == 'firstName') {
      dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { firstName: e.target.value } })
    }
    if (fieldName == 'lastName') {
      dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { lastName: e.target.value } })
    }
    if (fieldName == 'email') {
      dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { email: e.target.value } })
    }
    if (fieldName == 'comment') {
      dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { comment: e.target.value } })
    }
    if (fieldName == 'phone') {
      dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { phone: e.target.value } })
    }
  }

  return (
    <div>
      <div className="flex flex-row">
        {product.image ? (
          <div className="flex-shrink-0">
            <Image
              src={product.image?.secure_url}
              alt="Request Quote"
              width="200"
              height="200"
              className="rounded-lg object-cover object-center"
            />
          </div>
        ) : (
          <div className="h-[110px] w-[110px] bg-white"></div>
        )}
        <div className="flex gap-2 flex-col">
          <h3 className="text-lg pt-5 font-medium text-dark text-center">{product.name}</h3>
        </div>
      </div>
      <div className="p-4">
        <div className="flex flex-col gap-y-4">
          <div className="flex flex-row gap-3">
            <div className="w-1/2">
              <MlFormField
                type="text"
                label="First Name"
                name="first_name"
                onChange={(e) => handleChangeInput(e, 'firstName')}
                required
                autoComplete="given-name"
                value={quoteDetails?.firstName || ''}
                error={quoteDetails?.error == 'firstName'}
                errorMessage="This field is required."
              />
            </div>
            <div className="w-1/2">
              <MlFormField
                type="text"
                label="Last Name"
                name="last_name"
                onChange={(e) => handleChangeInput(e, 'lastName')}
                required
                autoComplete="family-name"
                value={quoteDetails?.lastName || ''}
                error={quoteDetails?.error == 'lastName'}
                errorMessage="This field is required."
              />
            </div>
          </div>

          <MlFormField
            type="email"
            label="Email"
            name="email"
            onChange={(e) => handleChangeInput(e, 'email')}
            required
            autoComplete="email"
            value={quoteDetails?.email || ''}
            error={quoteDetails?.error == 'email'}
            errorMessage="This field is required."
          />

          <MlFormField
            type="tel"
            label="Phone Number"
            name="phone"
            minLength={5}
            onChange={(e) => handleChangeInput(e, 'phone')}
            autoComplete="tel"
            value={quoteDetails?.phone || ''}
            // error={checkoutErrorsState.phone}
          />
          <MlFormField
            label="Comment"
            name="comment"
            onChange={(e) => handleChangeInput(e, 'comment')}
            autoComplete="comment"
            value={quoteDetails?.comment || ''}
            // error={checkoutErrorsState.phone}
            rows={2}
            type="textarea"
          />

          <div className="flex justify-center">
            {!!RECAPTCHA_SITE_KEY && (
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={() => {
                  dispatch({ type: FurnitureProductActionTypes.SET_PRODUCT_QUOTE, quoteState: { error: '' } })
                }}
              />
            )}
          </div>

          <div className="flex justify-center">
            <p className={`${quoteDetails?.error == 'recaptcha' ? '' : 'hidden'} text-red-600 block`}>
              {' '}
              Please Complete the ReCAPTCHA
            </p>
          </div>
          <div className="text-center p">
            A representative from our Customer Service team will respond to your request within 1-2 business days.
          </div>
        </div>
      </div>
    </div>
  )
}

export default TmCustomerService
